import { axios, BaseApiUrl, BaseUrl } from "../axios_config";

// 费用报价列表
export const GetFeeFileListAsync = (params) => {
	return axios
		.post(`${BaseApiUrl}/FeeFile/GetFeeFileListAsync`, {
			...params,
		})
		.then((res) => res.data);
};

export const FeeOrgDetailExport = `${BaseApiUrl}/FeeOrg/FeeOrgDetailExport`;

export const GetCurrencyServiceModelList = (params) => {
	return axios.post(`${BaseApiUrl}/Util/GetCurrencyServiceModelList`, params);
};

export const AddFeeDetail = (params) => {
	return axios.post(`${BaseApiUrl}/FeeOrg/AddFeeDetail`, params);
};

// 增值服务类型
export const GetFeeType = (params) => {
	return axios
		.get(`${BaseApiUrl}/AddServices/GetFeeType`, params)
		.then((res) => res.data);
};
export const AddServices = (params) => {
	return axios.post(`${BaseApiUrl}/AddServices/AddServices`, params);
};
// 修改增值服务状态
export const EditServiceStatus = (params) => {
	return axios.get(`${BaseApiUrl}/AddServices/EditServiceStatus`, {
		params: params,
	});
};

// 标记完成
export const CompleteServices = (params) => {
	return axios.post(`${BaseApiUrl}/AddServices/CompleteServices`, params);
};
export const AddServicesAsyncOut = `${BaseApiUrl}/AddServices/AddServicesAsyncOut`;

// 新增
export const ImportFeeFile = (params, urlParams) => {
	return axios.post(
		`${BaseApiUrl}/FeeFile/ImportFeeFile${urlParams || ""}`,
		params
	);
};

// 更新报价数据
export const UpdateFeeFileData = (params) => {
	return axios.post(`${BaseApiUrl}/FeeFile/UpdateFeeFileData`, params);
};
// 更新报价状态
export const UpdateFeeFileStatus = (params, urlParams) => {
	return axios.post(
		`${BaseApiUrl}/FeeFile/UpdateFeeFileStatus${urlParams || ""}`,
		params
	);
};

// 复制新增
export const CopyFeeFile = (params, urlParams) => {
	return axios.post(
		`${BaseApiUrl}/FeeFile/CopyFeeFile${urlParams || ""}`,
		params
	);
};

//导出模板
export const WesternTemplate = `${BaseUrl}/template/transfer/西邮智仓报价模板.xlsx`;